(() => {
  const cartItemsSelector = 'cart-items';
  const pendingQuantities = new Map();
  let updateRunning = false;

  const parseSection = (html) =>
    new DOMParser().parseFromString(html || '', 'text/html');

  const replaceSectionContents = (sectionHtml, selector) => {
    const source = parseSection(sectionHtml).querySelector(selector);
    const current = document.querySelector(selector);
    if (source && current) current.innerHTML = source.innerHTML;
  };

  const refreshAuxiliaryCartUI = (cart) => {
    const isEmpty = cart.item_count === 0;
    document.querySelector(cartItemsSelector)?.classList.toggle('is-empty', isEmpty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', isEmpty);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    document.querySelectorAll('free-shipping-progress').forEach((progress) => {
      if (typeof progress.refresh === 'function') progress.refresh();
    });
  };

  const submitLatestQuantity = async () => {
    if (updateRunning || pendingQuantities.size === 0) return;
    updateRunning = true;

    const [line, quantity] = pendingQuantities.entries().next().value;
    pendingQuantities.delete(line);

    const cartItems = document.querySelector(cartItemsSelector);
    const itemsSection = document.getElementById('main-cart-items')?.dataset.id;
    const footerSection = document.getElementById('main-cart-footer')?.dataset.id;
    const sectionIds = [itemsSection, footerSection, 'cart-icon-bubble'].filter(Boolean);
    const changeUrl = window.routes?.cart_change_url || '/cart/change.js';

    cartItems?.classList.add('cart-update-pending');

    try {
      const response = await fetch(changeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });

      const cart = await response.json();
      if (!response.ok || cart.status) {
        throw new Error(cart.description || cart.message || 'Unable to update cart');
      }

      if (cart.sections && itemsSection) {
        replaceSectionContents(cart.sections[itemsSection], '#main-cart-items .js-contents');
      }
      if (cart.sections && footerSection) {
        replaceSectionContents(cart.sections[footerSection], '#main-cart-footer .js-contents');
        replaceSectionContents(cart.sections[footerSection], '#main-cart-footer .cart-checkout-total');
      }

      const bubbleHtml = cart.sections?.['cart-icon-bubble'];
      if (bubbleHtml) replaceSectionContents(bubbleHtml, '#cart-icon-bubble');
      refreshAuxiliaryCartUI(cart);
    } catch (error) {
      const errors = document.getElementById('cart-errors');
      if (errors) errors.textContent = error.message || window.cartStrings?.error;
    } finally {
      updateRunning = false;
      cartItems?.classList.remove('cart-update-pending');
      if (pendingQuantities.size > 0) submitLatestQuantity();
    }
  };

  const queueLineQuantity = (lineValue, quantityValue) => {
    const line = Number(lineValue);
    const quantity = Math.max(0, Number(quantityValue));
    if (!line || Number.isNaN(quantity)) return;
    pendingQuantities.set(line, quantity);
    submitLatestQuantity();
  };

  const queueQuantity = (input) => {
    queueLineQuantity(input.dataset.index, input.value);
  };

  document.addEventListener(
    'click',
    (event) => {
      const removeLink = event.target.closest(`${cartItemsSelector} cart-remove-button a`);
      if (removeLink) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const removeButton = removeLink.closest('cart-remove-button');
        queueLineQuantity(removeButton?.dataset.index, 0);
        return;
      }

      const button = event.target.closest(`${cartItemsSelector} quantity-input button`);
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const input = button.closest('quantity-input')?.querySelector('input[name="updates[]"]');
      if (!input) return;

      if (button.name === 'plus') input.stepUp();
      if (button.name === 'minus') input.stepDown();
      queueQuantity(input);
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target.closest(`${cartItemsSelector} input[name="updates[]"]`);
      if (!input) return;
      event.stopImmediatePropagation();
      queueQuantity(input);
    },
    true
  );
})();
